<div>
  <div class="d-flex pb-4">
    <h2 class="h6">{{ 'global.registration.company-check.subtitle' | translate }}</h2>
    <a
      class="btn btn-link btn-link-secondary text-start text-uppercase ml-auto focus-border-large"
      data-test="unternehmenPruefung-anchor-addMoreCompanies"
      [routerLink]="[PARENT_ROUTE_COMPANY_SELECT]"
    >
      {{ 'global.registration.company-check.cta' | translate }}
    </a>
  </div>

  @for (item of this.sortedCompanies(); track item.gpNr; let index = $index) {
    <lib-ikp-info-card
      [infoCardType]="InfoCardType.LINK"
      [title]="item.name"
      actionText="{{ 'global.registration.company-check.entry.remove' | translate }}"
      actionColor="blue"
      (actionClicked)="checkboxClicked(item.gpNr)"
      [index]="index"
      dataTestPrefix="companyCheck"
    >
      <div class="row">
        <div class="col-sm-12 col-xl-4">
          <lib-ikp-info-input-read-only
            id="address"
            label="{{ 'global.address' | translate }}"
            [value]="getFormattedAddress(item.address)"
          />
        </div>
        <div class="col-sm-12 col-xl-4">
          <lib-ikp-info-input-read-only id="business-partner-id" label="{{ 'global.customerNr' | translate }}" [value]="item.gpNr" />
        </div>
        @if (false) {
          <div class="col-12 col-xl-4 d-flex flex-column" style="display: none">
            <a class="link p-2comma5" data-test="unternehmenPruefung-anchor-vknrDetailAnsicht">
              {{ 'global.registration.company-select.entry.cta' | translate }}
            </a>
          </div>
        }
        <div class="col-sm-12 col-xl-4">
          <lib-ikp-info-input-read-only
            id="uid"
            label="{{ 'global.registration.company-select.entry.uid' | translate }}"
            [value]="item.uid"
          />
        </div>
        <div class="col-sm-12 col-xl-4">
          <!-- data not available, not within the scope of mvp -->
          <lib-ikp-info-input-read-only
            id="industry"
            label="{{ 'global.registration.company-select.entry.industry' | translate }}"
            [value]="item.branche"
            style="display: none"
          />
        </div>
        <div class="col-sm-12 col-xl-4">
          <!-- data not available, not within the scope of mvp -->
          <lib-ikp-info-input-read-only
            id="employeecount'"
            label="{{ 'global.registration.company-select.entry.size' | translate }}"
            [value]="item.mitarbeiterAnzahl"
            style="display: none"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xl-4">
          <lib-ikp-info-input-read-only
            id="email"
            label="{{ 'global.registration.company-select.entry.email' | translate }}"
            [value]="item.email"
          />
        </div>
      </div>
    </lib-ikp-info-card>
  }
</div>
